import React, { useState, useRef, useEffect } from 'react';
import { Box, IconButton } from '@mui/material';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';

const ResizableImage = ({ id, alt = '' }) => {
    const imgRef = useRef(null);
    const [naturalSize, setNaturalSize] = useState({ width: 100, height: 100 });
    const [scale, setScale] = useState(1);

    const handleLoad = (e) => {
        const { naturalWidth, naturalHeight } = e.currentTarget;
        setNaturalSize({ width: naturalWidth, height: naturalHeight });

    };

    const getMaxScale = () => {
        const width = window.innerWidth - 40;
        const height = window.innerHeight - 100;
        const scaleWidth = width / naturalSize.width;
        const scaleHeight = height / naturalSize.height;
        console.log(Math.min(scaleWidth, scaleHeight, 5))
        return Math.min(scaleWidth, scaleHeight, 5);
    };

    const handleError = (event) => {
        console.log(event);
        if (event.target.className.includes('fallback')) return;
    };
    const updateScale = () => {
        const viewportWidth = window.innerWidth - 40;
        const viewportHeight = window.innerHeight - 100;

        const scaleWidth = (viewportWidth / naturalSize.width) ;
        const scaleHeight = (viewportHeight / naturalSize.height) * 0.5;

        setScale(Math.min(scaleWidth, scaleHeight, 1));
    };
    useEffect(() => {
        if (naturalSize.width === 0 || naturalSize.height === 0) return;
        updateScale();

        window.addEventListener('resize', updateScale);
        return () => window.removeEventListener('resize', updateScale);
    }, [naturalSize]);
    return (
        <Box display="flex" flexDirection="column" alignItems="center">
            <Box  position="absolute"
                  top={8}
                  zIndex={9000}
                  display="flex"
                  flexDirection="row"
                  gap={1}   >
                <IconButton onClick={() => setScale(prev => Math.min(prev + 0.25, getMaxScale()))}>
                    <ZoomInIcon />
                </IconButton>
                <IconButton onClick={() => setScale(prev => Math.max(prev - 0.25, 0.25))}>
                    <ZoomOutIcon />
                </IconButton>
            </Box>
            <Box
                component="img"
                ref={imgRef}
                src={id}
                alt={alt}
                onLoad={handleLoad}
                onError={handleError}
                mt={6}
                sx={{

                    width: `${naturalSize.width * scale}px`,
                    height: 'auto',
                    minWidth: '100px',
                    minHeight: '100px',
                    transition: 'width 0.2s ease',
                    cursor: 'pointer',
                    display: 'block',
                    overflow: 'auto',
                }}
            />
        </Box>
    );
};

export default ResizableImage;
